export default __webpack_public_path__ + "static/media/step_B@2x.b3b579ed.png";